/**
 * Status einer Geburtstagsbuchung
 */
export enum BirthdayBookingStatus {
   /**
    * Buchungsanfrage vom Kunden erhalten, aber es ist noch unklar welcher Mitarbeiter dass betreuen soll.
    */
   requestedStaffRequired = "requestedStaffRequired",

   /**
    * deprecated
    * Buchungsanfrage vom Kunden erhalten, aber es konnte kein verfügbarer Mitarbeiter gefunden werden.
    */
   requestedNoStaffAvailable = "requestedNoStaffAvailable",

   /**
    * Buchungsanfrage vom Kunden erhalten und ein Mitarbeiter wurde gefunden (sofern einer benötigt wird). Verwaltung muss Termin bestätigen.
    */
   requestedPendingConfirmation = "requestedPendingConfirmation",

   /**
    * Buchungsanfrage akzeptiert, Kunde muss Buchung bestätigen.
    */
   offerToCustomer = "offerToCustomer",

   /**
    * Buchung ist vollständig, Termin kann stattfinden.
    */
   booked = "booked",

   /**
    * Geburtstag durchgeführt, Rechnung kann gestellt werden.
    */
   readyForPayment = "readyForPayment",

   /**
    * Rechnung wurde exportiert. Jetzt ist nichts mehr zu tun.
    */
   paymentExported = "paymentExported",

   /**
    * Geburtstag wurde von Kunde storniert. Mitarbeiter:in muss Stornierung bestaetigen.
    */
   cancellationPending = "cancellationPending",

   /**
    * Geburtstag wurde storniert. Gebuehren Export ausstehend.
    */
   canceled = "canceled",

   /**
    * Geburtstag ist abgesagt und Stornierungsgebuehr wurde exportiert.
    */
   cancellationFeeExported = "cancellationFeeExported"
}